export default "__VITE_ASSET__2ff5ca34__"